export enum QuickLinkTypeEnum {
  ORGANIZATION = 'ORGANIZATION',
  PROFILE = 'PROFILE',
  STATIC_DATA = 'STATIC_DATA',
}
